var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowUpCircle28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4999 26C21.1273 26 26.4999 20.6274 26.4999 14C26.4999 7.37258 21.1273 2 14.4999 2C7.87244 2 2.49986 7.37258 2.49986 14C2.49986 20.6274 7.87244 26 14.4999 26ZM15.3837 7.24712C14.8956 6.75896 14.1041 6.75896 13.616 7.24712L9.37331 11.4898C8.88516 11.9779 8.88516 12.7694 9.37331 13.2575C9.86147 13.7457 10.6529 13.7457 11.1411 13.2575L13.2498 11.1488V20.3639C13.2498 21.0543 13.8095 21.6139 14.4998 21.6139C15.1902 21.6139 15.7498 21.0543 15.7498 20.3639V11.1488L17.8586 13.2575C18.3467 13.7457 19.1382 13.7457 19.6264 13.2575C20.1145 12.7694 20.1145 11.9779 19.6264 11.4898L15.3837 7.24712Z",
    fill: "#2EA7E5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpCircle28);
export default __webpack_public_path__ + "static/media/arrow_up_circle_28.b56041f5.svg";
export { ForwardRef as ReactComponent };